import {WinPresentationController} from "../WinPresentationController";
import {TheRave} from "../../TheRave";
import {TheRaveGameMode} from "../../gameflow/TheRaveGameMode";

export class FreespinM1MultiplierReveal extends WinPresentationController {

   constructor() {
      super("FreespinM1MultiplierReveal", true);
   }

   protected hasWin():boolean {
      return (TheRave.model.currentParsedData.mode === TheRaveGameMode.FREESPIN_SUPER);
   }

   protected async createWinAnimation():Promise<void> {
      await TheRave.stickySymbol.update();
   }

   public skip():void {}
}